/**
 * Base validation limits for templates
 * Platform-specific overrides should be applied when using these
 */

/**
 * Base template limits that are common across platforms
 */
export const BASE_TEMPLATE_LIMITS = {
  // Body message
  BODY_MAX_LENGTH: 1024,
  NAME_MIN_LENGTH: 1,

  // Quick Reply limits
  QUICK_REPLY_BUTTON_TITLE_MAX_LENGTH: 20,
  QUICK_REPLY_BUTTON_ID_MAX_LENGTH: 200,
  QUICK_REPLY_MIN_BUTTONS: 1,
  QUICK_REPLY_MAX_BUTTONS: 10,

  // Call-to-Action limits
  CALL_TO_ACTION_BUTTON_TITLE_MAX_LENGTH: 20,
  CALL_TO_ACTION_URL_MAX_LENGTH: 2000,
  CALL_TO_ACTION_PHONE_MAX_LENGTH: 20,
  CALL_TO_ACTION_CODE_MAX_LENGTH: 15,
  CALL_TO_ACTION_MIN_BUTTONS: 1,
  CALL_TO_ACTION_MAX_BUTTONS: 4,
  CALL_TO_ACTION_MAX_URL_BUTTONS: 2,
  CALL_TO_ACTION_MAX_PHONE_BUTTONS: 1,
  CALL_TO_ACTION_MAX_COPY_CODE_BUTTONS: 1,
  CALL_TO_ACTION_MAX_VOICE_CALL_BUTTONS: 1,
  CALL_TO_ACTION_MAX_VOICE_CALL_REQUEST_BUTTONS: 1,

  // TTL limits
  MIN_TTL_MINUTES: 1,
  MAX_TTL_MINUTES: 43200, // 30 days
  DEFAULT_TTL_MINUTES: 10080, // 7 days

  // Variable limits
  MAX_VARIABLES: 100,
  VARIABLE_VALUE_MAX_LENGTH: 200,
};

/**
 * Factory to create platform-specific limits by merging base with overrides
 * @param {Object} overrides - Platform-specific overrides
 * @returns {Object} Merged limits object
 */
export const createPlatformLimits = (overrides = {}) => ({
  ...BASE_TEMPLATE_LIMITS,
  ...overrides,
});

/**
 * Regex patterns for validation (shared)
 */
export const VALIDATION_PATTERNS = {
  // Variable detection patterns
  NUMERIC_VARIABLE: /\{\{(\d+)\}\}/g,
  ALL_VARIABLES: /\{\{[^}]+\}\}/g,

  // Phone E.164 format
  PHONE_E164: /^\+[1-9]\d{1,14}$/,

  // URL with http/https
  URL_PROTOCOL: /^https?:\/\/.+/,

  // Template name (lowercase, underscore)
  TEMPLATE_NAME: /^[a-z][a-z0-9_]*$/,
};
